export enum COST_DOCUMENT_PAIR_TYPE {
  PairToOriginal = 1,
  PairToClone = 2,
}
